<footer>
  <div id="footer" class="principal-container font-weight-bold p-3 d-flex justify-content-end">
    <div class="fs-m mx-2 mx-xl-3 clickable underline" (click)="redirectToHelp()">
      {{ 'Ayuda' | translate }}
    </div>
  </div>
</footer>


